module.exports = __webpack_public_path__ + "img/nakladnoy_logo_2.f31bf794.jpg";